export { default as Editor } from './Editor/Editor'
export { default as About } from './About/About'
export { default as Privacy } from './Privacy/Privacy'
export { default as NewFile } from './NewFile/NewFile'
export { default as Landing } from './Landing/Landing'
export { default as NotFound } from './NotFound/NotFound'
export { default as Share } from './Share/Share'
export { default as Preferences } from './Preferences/Preferences'
export { default as TutorialsPage } from './Tutorials/TutorialsPage'
export { default as Example } from './Example/Example'
